import * as Sentry from '@sentry/nextjs';

// The submission id goes on Sentry rather than a Datadog tag, which bills on
// unique tag combinations.
// eslint-disable-next-line import/prefer-default-export
export const captureWithSubmissionId = ({ error, submissionId }) => {
  Sentry.withScope((scope) => {
    scope.setTag('client_api_submission_id', String(submissionId));
    Sentry.captureException(error);
  });
};
